module.exports = __webpack_public_path__ + "static/media/equation_test.655b568e.docx";